module.exports = __webpack_public_path__ + "static/img/discussion_member_02_ph.0a89e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/discussion_member_02_ph.png
// module id = 8pG4
// module chunks = 0